import { useState } from 'react';

import {
  createDateRangeStartAtEndAtMapping,
  DateRange,
  YESTERDAY,
} from '@/lib/charts';

export const useDateRangeToggle = () => {
  const [dateRangeToggleValue, setDateRangeToggleValue] = useState<DateRange>(
    DateRange.WEEK
  );

  // Start date/time of dates range selection
  const [anchorDate, setAnchorDate] = useState<Date>(YESTERDAY);

  // Date/time at the start and end of the date range
  const dateRangeStartAtEndAtMapping = createDateRangeStartAtEndAtMapping(
    new Date(anchorDate)
  );

  return {
    dateRangeToggleValue,
    setDateRangeToggleValue,
    dateRangeStartAtEndAtMapping,
    setAnchorDate,
    anchorDate,
  };
};
